import React from 'react';
import { Card, Alert, Empty } from 'antd';

interface DueDiligenceStepProps {
  module: string | null;
  projectCode: string;
}

const DueDiligenceStep: React.FC<DueDiligenceStepProps> = ({
  module,
  projectCode,
}) => {
  if (!module) {
    return (
      <Alert
        message="请选择要操作的尽职调查模块"
        description="请从左侧导航中选择具体的尽调模块"
        type="info"
        showIcon
      />
    );
  }

  return (
    <Card title={`尽职调查 - ${module}`}>
      <Alert
        message="暂无内容"
        description={`模块 "${module}" 暂无可用内容`}
        type="info"
        showIcon
      />
    </Card>
  );
};

export default DueDiligenceStep;
